function uploadDone({ state, input }) {
  let path = input.path
  state.merge(path.concat('.value'), {
    uploadDone: true,
    url: input.url,
    id: input.id
  })
}

export default uploadDone



// WEBPACK FOOTER //
// ./src/modules/user/actions/uploadDone.js